export function range(n: number): number[] {
  const xs: number[] = []

  for (let i = 0; i < n; i++) {
    xs.push(i)
  }

  return xs
}


export function formatTime(t: number): string {
  const min = Math.floor(t / (60 * 1000))
  let sec = (Math.floor(t / 1000) % 60).toString()

  if (sec.length == 1) {
    sec = '0' + sec
  }

  return `${min}:${sec}`
}


export function clamp(x: number, a: number, b: number): number {
  return Math.min(Math.max(x, a), b)
}


export function preventBack(msg: string) {
  let prevent = false

  history.pushState(null, document.title, location.href)
  window.addEventListener('popstate', function (_event) {
    if (prevent) {
      history.back()
      return
    }
    if (confirm(msg)) {
      prevent = true
      history.back()
    } else {
      history.pushState(null, document.title, location.href)
    }
  })
}


export function preventRightClick() {
  document.addEventListener('contextmenu', e => {
    e.preventDefault()
  })
}


// WEBPACK FOOTER //
// ./src/service/util.ts